'use client'

import { TransactionSide } from '@marketplace-web/complaints/complaints-data'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

type RenderProps = {
  transactionId?: number
  complaintId?: string | null
  userSide?: TransactionSide | null
}

type Props = {
  children: (props: RenderProps) => JSX.Element
}

const ResolveComplaintConversationWrapper = ({ children }: Props) => {
  const { transaction } = useConversationContext()
  const transactionId = transaction?.id
  const complaintId = transaction?.complaintId
  const userSide = transaction?.userSide

  return children({ transactionId, complaintId, userSide })
}

export default ResolveComplaintConversationWrapper
